import {
    animate,
    keyframes,
    state,
    style,
    transition,
    trigger
  } from '@angular/animations';
  import { Component } from '@angular/core';
  import { CommonModule } from '@angular/common';
  import { BrowserModule } from '@angular/platform-browser';
  
  import { Toast, ToastrService, ToastPackage, IndividualConfig} from 'ngx-toastr';
  
  export interface IToastButton {
    name: string;
    class: string;
    action: any;
  };
  
  @Component({
    selector: '[custom-toast-component]',
    styleUrls: [`./custom-toast-component.css`],
    templateUrl: `./custom-toast-component.html`,
    imports: [ CommonModule,BrowserModule ],
    animations: [
        trigger('flyInOut', [
          state('inactive', style({ opacity: 0 })),
          state('active', style({ opacity: 1 })),
          state('removed', style({ opacity: 0 })),
          transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
          transition('active => removed', animate('{{ easeTime }}ms {{ easing }}')),
        ]),
      ],
    preserveWhitespaces: false,
  })
  export class CustomToastComponent extends Toast {
  
    // constructor is only necessary when not using AoT
    constructor(
      protected toastrService: ToastrService,
      public toastPackage: ToastPackage,
    ) {
      super(toastrService, toastPackage);
    }
  
    action(btn: IToastButton) {
      event.stopPropagation();
      console.log('In action');
      btn.action();
      this.toastPackage.triggerAction();
      this.toastrService.clear();
      return false;
    }
  }